import { render, staticRenderFns } from "./SigninScreen.vue?vue&type=template&id=3e5a7f1c&scoped=true"
import script from "./SigninScreen.vue?vue&type=script&lang=js"
export * from "./SigninScreen.vue?vue&type=script&lang=js"
import style0 from "./SigninScreen.vue?vue&type=style&index=0&id=3e5a7f1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5a7f1c",
  null
  
)

export default component.exports